import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const QrCodeIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M4.75 3.5C4.05964 3.5 3.5 4.05964 3.5 4.75V8.75C3.5 9.16421 3.16421 9.5 2.75 9.5C2.33579 9.5 2 9.16421 2 8.75V4.75C2 3.23122 3.23122 2 4.75 2H7.75C8.16421 2 8.5 2.33579 8.5 2.75C8.5 3.16421 8.16421 3.5 7.75 3.5H4.75Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
          <path
            d="M9 6.5H7C6.72386 6.5 6.5 6.72386 6.5 7V9C6.5 9.27614 6.72386 9.5 7 9.5H9C9.27614 9.5 9.5 9.27614 9.5 9V7C9.5 6.72386 9.27614 6.5 9 6.5zM7 5C5.89543 5 5 5.89543 5 7V9C5 10.1046 5.89543 11 7 11H9C10.1046 11 11 10.1046 11 9V7C11 5.89543 10.1046 5 9 5H7zM9 14.5H7C6.72386 14.5 6.5 14.7239 6.5 15V17C6.5 17.2761 6.72386 17.5 7 17.5H9C9.27614 17.5 9.5 17.2761 9.5 17V15C9.5 14.7239 9.27614 14.5 9 14.5zM7 13C5.89543 13 5 13.8954 5 15V17C5 18.1046 5.89543 19 7 19H9C10.1046 19 11 18.1046 11 17V15C11 13.8954 10.1046 13 9 13H7z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
          <path
            d="M13 15C13 13.8954 13.8954 13 15 13H17C18.1046 13 19 13.8954 19 15V17C19 18.1046 18.1046 19 17 19H15C13.8954 19 13 18.1046 13 17V15Z"
            fill="#222"
          />
          <path
            d="M17 7H15V9H17V7zM15 5C13.8954 5 13 5.89543 13 7V9C13 10.1046 13.8954 11 15 11H17C18.1046 11 19 10.1046 19 9V7C19 5.89543 18.1046 5 17 5H15zM3.5 19.25C3.5 19.9404 4.05964 20.5 4.75 20.5H8.75C9.16421 20.5 9.5 20.8358 9.5 21.25 9.5 21.6642 9.16421 22 8.75 22H4.75C3.23122 22 2 20.7688 2 19.25L2 15.25C2 14.8358 2.33579 14.5 2.75 14.5 3.16421 14.5 3.5 14.8358 3.5 15.25L3.5 19.25zM19.25 20.5C19.9404 20.5 20.5 19.9404 20.5 19.25V15.25C20.5 14.8358 20.8358 14.5 21.25 14.5 21.6642 14.5 22 14.8358 22 15.25V19.25C22 20.7688 20.7688 22 19.25 22H15.25C14.8358 22 14.5 21.6642 14.5 21.25 14.5 20.8358 14.8358 20.5 15.25 20.5H19.25z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
          <path
            d="M20.5 4.75C20.5 4.05964 19.9404 3.5 19.25 3.5L15.25 3.5C14.8358 3.5 14.5 3.16421 14.5 2.75C14.5 2.33579 14.8358 2 15.25 2L19.25 2C20.7688 2 22 3.23122 22 4.75V8.75C22 9.16421 21.6642 9.5 21.25 9.5C20.8358 9.5 20.5 9.16421 20.5 8.75V4.75Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
        </svg>
      </IconWrapper>
    )
  },
)
